<template>
  <div :class="mobile_container_class" ref="mobileContainer">
    <div
      class="filler filler-top overflow-hidden"
      ref="filler_top"
      :style="filler_top_style"
    ></div>
    <iframe
      style="width: 100%; height: 100%;"
      src="static/iframe/allergan.html"
      ref="iframe"
    ></iframe>
    <!--    <transition name="fade" mode="out-in">-->
    <!--      <AppSidebar />-->
    <!--    </transition>-->
  </div>
</template>
<script>
import AppSidebar from "./AppSidebar";
import { VueperSlides, VueperSlide } from "vueperslides";
import { mapGetters, mapState } from "vuex";
import store from "../store";
export default {
  name: "MobileContainer",
  components: {
    AppSidebar,
    VueperSlides,
    VueperSlide
  },
  data() {
    return { top_filler_height: 0, parentRatio: 0, resize_timer: null };
  },
  computed: {
    ...mapState([
      "sections",
      "current_section",
      "current_ambience_vol",
      "ambience_max_volume",
      "ambience_volume",
      "ambience_previous_vol"
    ]),
    ...mapGetters(["sectionCount", "eventTag", "getSection"]),

    filler_top_style() {
      if (this.top_filler_height > 0) {
        return {
          height: this.top_filler_height + "px"
        };
      }
      return {};
    },
    mobile_container_class() {
      let str = "mobile-container mx-auto mb-auto";

      return str;
    }
  },
  methods: {
    send_interactive_msg(msg, param) {
      console.log("mobile got message", msg, param, param * 1 < 7);
      switch (msg) {
        case "JsRequestSection":
          if (param != "" && "undefined" != typeof param) {
            //if the requested section is inside the range of number of sections
            //then we are requesting a normal section
            //otherwise we are requesting it goes home
            if (param * 1 <= this.sectionCount) {
              this.$refs.iframe.contentWindow.postMessage(
                "switch_area:" + param,
                "*"
              );

              try {
                var page_title = this.getSection(param).name;
                var slug = page_title
                  .split(" ")
                  .join("-")
                  .split("/")
                  .join("-")
                  .toLowerCase();
                this.$ga.page("/" + this.eventTag + "/" + slug);
              } catch (err) {}
            } else {
              //home
              this.$refs.iframe.contentWindow.postMessage(
                "switch_area:" + 0,
                "*"
              );

              try {
                var slug = "home";
                this.$ga.page("/" + this.eventTag + "/" + slug);
              } catch (err) {}
            }
            this.request_voiceover(param + "");
          }
          break;
        default:
          this.$refs.iframe.contentWindow.postMessage(msg + ":" + param, "*");
          break;
      }
    },

    get_section_index(id) {
      let section_index = -1;
      this.sections.forEach((item, idx) => {
        if (id + "" == item.id) {
          section_index = idx;
        }
      });
      return section_index;
    },
    on_audio_end(section) {
      console.log("audio ended", section);
      //let's see if it's a voiceover, and if so, set it to not play again
      this.sections.forEach((item) => {
        if (item.has_voiceover && item.id == section + "") {
          this.$store.dispatch("set_voiceover_played", section);
          this.$store.dispatch("set_simple_val", {
            name: "ambience_max_volume",
            val: this.ambience_volume
          });
          this.$bus.$emit("try-to-increase-ambience", this.ambience_max_volume);
        }
      });
    },
    //when a video is created we have to stop the section voiceover
    on_video_created() {
      this.$store.dispatch("set_simple_val", {
        name: "ambience_max_volume",
        val: this.ambience_volume
      });

      let section_index = this.get_section_index(this.current_section);

      if (section_index >= 0) {
        this.$bus.$emit("on-request-fade-and-stop", this.current_section);
        if (!this.sections[section_index].voiceover_has_played) {
          this.$store.dispatch("set_voiceover_played", this.current_section);
        }
      }
    },
    request_voiceover(section) {
      //voiceovers play once, so let's make sure
      //the requested section has a voiceover and that it hasn't played yet
      let requested_section_index = this.get_section_index(section);

      if (
        requested_section_index >= 0 &&
        "undefined" !=
          typeof this.sections[requested_section_index].has_voiceover &&
        this.sections[requested_section_index].has_voiceover &&
        !this.sections[requested_section_index].voiceover_has_played
      ) {
        this.sections.forEach((item) => {
          //other voiceover might be playing so let's stop them
          if (item.has_voiceover && item.id != section + "") {
            this.$bus.$emit("on-request-audio-stop", item.id);
          }
        });
        this.$store.dispatch("set_simple_val", {
          name: "ambience_max_volume",
          val: 0.02
        });
        this.$bus.$emit("try-to-lower-ambience", this.ambience_max_volume);
        this.$bus.$emit("on-request-audio", section);
      } else {
        this.sections.forEach((item) => {
          //other voiceover might be playing so let's stop them
          if (item.has_voiceover) {
            this.$bus.$emit("on-request-audio-stop", item.id);
          }
        });

        this.$store.dispatch("set_simple_val", {
          name: "ambience_max_volume",
          val: this.ambience_volume
        });
        this.$bus.$emit("try-to-increase-ambience", this.ambience_max_volume);
      }
    },
    do_resize() {
      if (
        this.$refs.mobileContainer &&
        this.$refs.mobileContainer.parentNode.className.indexOf("active") < 0
      ) {
        return;
      }

      if (this.resize_timer) {
        clearTimeout(this.resize_timer);
        this.resize_timer = null;
      }
      this.resize_timer = setTimeout(this.do_delayed_resize.bind(this), 15);
    },
    do_delayed_resize() {
      //reduce the height so we can calculate things
      this.$refs.mobileContainer.style.height = "40vh";
      this.top_filler_height = 0;

      let optimalRatio = 9 / 16;
      let secondaryPortraitOptimalRatio = 9 / 16;
      let secondaryLandscapeOptimalRatio = 8.9 / 16;

      let parentWidth = this.$refs.mobileContainer.parentNode.clientWidth;
      let parentHeight = this.$refs.mobileContainer.parentNode.clientHeight;
      let parentRatio = parentHeight / parentWidth;
      let finalWidth = parentWidth;

      //this means the current content is wider than what it should, and
      //it'll move the top logo out of the window
      //so we have to make it respect the optimal ratio
      if (parentRatio <= optimalRatio) {
        //if wider
        if (parentRatio <= secondaryLandscapeOptimalRatio) {
          this.$refs.mobileContainer.style.width =
            parentHeight / optimalRatio + "px";
          this.$refs.mobileContainer.style.height = parentHeight + "px";
          finalWidth = parentHeight / optimalRatio;
        } else {
          this.$refs.mobileContainer.style.width = parentWidth + "px";
          this.$refs.mobileContainer.style.height = parentHeight + "px";
        }
      } else {
        //this means we're in portrait mode
        //we can sacrifice a bit of the sides of the app
        //so we use the secondary optimal ratio;
        if (parentRatio <= secondaryPortraitOptimalRatio) {
          this.$refs.mobileContainer.style.width = parentWidth + "px";
          this.$refs.mobileContainer.style.height = parentHeight + "px";
        } else {
          this.$refs.mobileContainer.style.width = parentWidth + "px";
          this.$refs.mobileContainer.style.height =
            parentWidth * secondaryPortraitOptimalRatio + "px";
        }
      }
      if (parentRatio < 0.7) {
        this.top_filler_height = Math.floor(
          (parentHeight - this.$refs.mobileContainer.clientHeight) * 0.5
        );
      } else {
        this.top_filler_height = 0;
      }
      this.parentRatio = parentRatio;
      this.$store.dispatch("set_app_width", finalWidth + "px");
      this.$store.dispatch("set_simple_val", {
        name: "parentRatio",
        val: parentRatio
      });
    },
    fix_dimensions() {
      this.do_resize();
      window.addEventListener(
        "resize",
        function () {
          this.do_resize();
        }.bind(this)
      );
    },
    on_activating_content(isactive) {
      //
      setTimeout(
        function () {
          console.log("activating content");
          this.$nextTick(this.do_resize);
        }.bind(this),
        400
      );
      setTimeout(
        function () {
          this.$store.dispatch("set_popup_state", "instructions");
        }.bind(this),
        900
      );
    }
  },
  mounted() {
    console.log("mounted iframe container");
    this.$bus.$on("send_interactive_msg", this.send_interactive_msg);
    this.$bus.$on("on-video-created", this.on_video_created);
    this.$bus.$on("on-activating-content", this.on_activating_content);

    this.$bus.$on("on-audio-end", this.on_audio_end);
    this.fix_dimensions();

    try {
      var slug = "home";
      this.$ga.page("/" + this.eventTag + "/" + slug);
    } catch (err) {}

    window.addEventListener(
      "message",
      function (event) {
        if ("string" != typeof event.data) return;
        console.log(event.data, event);

        var command = event.data.split(":");
        var cat = command[0];

        switch (cat) {
          case "on_app_started":
            store.dispatch("set_app_state", 0);

            break;
          case "on_transition_started":
            // store.dispatch('set_video_popup', msg.toLowerCase());

            bus.$emit("on-transition-started", msg.toLowerCase());
            break;
          case "on_transition_ended":
            bus.$emit("on-transition-ended", msg.toLowerCase());
            break;
          case "on_section_anim_ended":
            this.$bus.$emit("on-section-anim-ended", {
              id: command[1],
              subid: command[2]
            });
            break;
          case "area_btn":
            bus.$emit("on-area-btn-click", msg.toLowerCase());
            break;
        }
      }.bind(this)
    );
  }
};
</script>
<style>
.mobile-container img {
  width: 100%;
  height: 100%;
}
.mobile-container {
}
.mobile-container .vueperslides {
  width: 100vw;
  color: #f0f0f0;
}
.mobile-container .vueperslides--fixed-height {
  xheight: calc(var(--vh, 1vh) * 100);
  height: 100%;
}
.mobile-container .vueperslide__content {
  height: 100%;
  width: 100%;
}
.mobile-container .app_sidebar {
  z-index: 10;
}
.slide-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.filler-top {
  background: #2c5792;
}
</style>



// WEBPACK FOOTER //
// src/components/IframeContainer.vue